module.exports = __webpack_public_path__ + "static/media/demo-10.16b9c2b9.jpg";